import { Form, Input, Button, message, Modal, InputNumber, Row, Col } from "antd";
import { useEffect } from "react";
import axios from "axios";

export default function Nom013IluminacionForm(props) {
  const { visible, title, mainData: verification, setMainData: setVerification, setVisible } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (verification) {
      form.setFieldsValue(verification);
    }
  }, [verification, form]);

  const onFinish = (values) => {
    const verificationData = {
      ...verification,
      ...values,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/verificaciones/${verification.VerificacionID}`, verificationData)
      .then(() => {
        message.success("Campos actualizados correctamente");
        setVerification(verificationData);
        setVisible(false);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al actualizar los campos");
      });
  };

  return (
    <Modal title={title} visible={visible} onCancel={() => setVisible(false)} footer={null} width={800} centered>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="TipoLampara" label="Tipo de Lámpara">
          <Input />
        </Form.Item>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="PotenciaSistema" label="Potencia del Sistema">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="IluminanciaMinima" label="Iluminancia Mínima">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="SuperficieDPEA" label="Superficie DPEA">
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" htmlType="submit">
          Guardar
        </Button>
      </Form>
    </Modal>
  );
}
